<p-toast></p-toast>
<p-toolbar>
  <ng-template pTemplate="left">
    <button pButton pRipple label="Новий учасник" icon="pi pi-plus" class="p-button-success mr-2" [disabled]="editMode" (click)="addTeamMember()"></button>
  </ng-template>
  <ng-template pTemplate="right">
    <p-button icon="pi pi-refresh" label="Оновити" (onClick)="reloadTable()" [disabled]="editMode"
              pTooltip="Оновити список команди" tooltipPosition="top"></p-button>
  </ng-template>
</p-toolbar>

<p-table #ATM1 [value]="teamMembers"
         [rowHover]="true"
         [resizableColumns]="true"
         editMode="row"
         dataKey="uid"
         styleClass="p-datatable p-datatable-gridlines p-datatable-striped">
  <ng-template pTemplate="header">
    <tr>
      <th style="width:6rem"></th>
      <th width="10%">Статус</th>
      <th width="26%">Teams GUID</th>
      <th width="24%">Ім'я</th>
      <th width="20%">Компанія</th>
      <th width="12%">Ескалація</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-member let-editing="editing" let-ri="rowIndex">
    <tr [pEditableRow]="member">
      <td>
        <button *ngIf="!editing && !editMode" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(member)" class="p-button-rounded p-button-text"></button>
        <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(member)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
        <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onRowEditCancel(member, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <p-checkbox [(ngModel)]="member.active" [binary]="true"></p-checkbox>
          </ng-template>
          <ng-template pTemplate="output">
            <p-tag [severity]="member.active ? 'success' : 'danger'" [value]="member.active ? 'Активний' : 'Неактивний'"></p-tag>
          </ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input"><input pInputText type="text" [(ngModel)]="member.teams_user_id" style="width:100%" placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"></ng-template>
          <ng-template pTemplate="output">{{member.teams_user_id}}</ng-template>
        </p-cellEditor>
      </td>
      <td style="overflow: visible !important">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <app-personselector [parentCompany]="mainCompanyId" [selectedID]="member.person_id" [showClear]="true" [showLabel]="false"
                                placeholder="Обрати користувача..." (selectedPersonID)="onPersonSelected(member, $event)" [style]="{'width':'100%'}"></app-personselector>
          </ng-template>
          <ng-template pTemplate="output">{{member.display_name}}</ng-template>
        </p-cellEditor>
      </td>
      <td style="overflow: visible !important">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <app-companyselector [parentCompany]="mainCompanyId" [selectedID]="member.preferred_company_id" [showLabel]="false"
                                 [showEditButton]="false" [showAddButton]="false" [showSearchButton]="false"
                                 placeholder="Обрати компанію..." (selectedCompanyID)="member.preferred_company_id = $event" [style]="{'width':'100%'}"></app-companyselector>
          </ng-template>
          <ng-template pTemplate="output">{{companyName(member.preferred_company_id)}}</ng-template>
        </p-cellEditor>
      </td>
      <td>
        <p-cellEditor>
          <ng-template pTemplate="input">
            <p-checkbox [(ngModel)]="member.is_escalation_contact" [binary]="true"></p-checkbox>
          </ng-template>
          <ng-template pTemplate="output">{{member.is_escalation_contact ? 'Так' : 'Ні'}}</ng-template>
        </p-cellEditor>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr><td colspan="6">Немає учасників команди агента</td></tr>
  </ng-template>
</p-table>
